import React, { useState } from 'react';
import { addCard } from '../api/learning-cards';
import { CARD_SIDE_TYPE_LABELS } from '../constants/learning-cards';

function AddCardModal({ show, groupId, group, onClose, onCardAdded }) {
    const [formData, setFormData] = useState({
        side1_text: '',
        side2_text: ''
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.side1_text.trim() || !formData.side2_text.trim()) {
            setError('Both sides are required');
            return;
        }

        setError('');
        setLoading(true);

        try {
            const result = await addCard({
                group_id: parseInt(groupId),
                sides_text: [formData.side1_text.trim(), formData.side2_text.trim()]
            });

            if (result.success) {
                setFormData({
                    side1_text: '',
                    side2_text: ''
                });

                if (onCardAdded) {
                    onCardAdded();
                }

                onClose();
            } else {
                setError(result.message || 'Failed to add card');
            }
        } catch (err) {
            setError('An unexpected error occurred. Please try again.');
            console.error('Add card error:', err);
        } finally {
            setLoading(false);
        }
    };

    const getSideLabel = (sideIndex) => {
        const groupCardSideTypes = group?.cardSideTypes || group?.card_side_types || [];
        const sideType = groupCardSideTypes[sideIndex] || 'CARD_SIDE_NULL';
        const typeLabel = CARD_SIDE_TYPE_LABELS[sideType] || 'Standard';
        return `Side ${sideIndex + 1} (${typeLabel})`;
    };

    if (!show) return null;

    return (
        <>
            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1040 }}
                onClick={onClose}
            ></div>

            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ zIndex: 1050 }}
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ pointerEvents: 'auto' }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add New Card</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <div className="mb-3">
                                    <label htmlFor="side1_text" className="form-label">
                                        {getSideLabel(0)}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="side1_text"
                                        rows="3"
                                        value={formData.side1_text}
                                        onChange={handleChange}
                                        disabled={loading}
                                        required
                                        placeholder="Enter text for the first side"
                                    ></textarea>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="side2_text" className="form-label">
                                        {getSideLabel(1)}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="side2_text"
                                        rows="3"
                                        value={formData.side2_text}
                                        onChange={handleChange}
                                        disabled={loading}
                                        required
                                        placeholder="Enter text for the second side"
                                    ></textarea>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Adding...
                                        </>
                                    ) : (
                                        'Add Card'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCardModal;